import React from "react";
import { NavLink } from "react-router-dom";
import "./sidebar.css";
import {
  FaChevronLeft,
  FaThLarge,
  FaExchangeAlt,
  FaCog,
  FaBitcoin,
  FaChartLine,
  FaLink,
} from "react-icons/fa";

const Sidebar = ({ sidebarOpen, setSidebarOpen }) => {
  const handleLinkClick = () => {
    if (window.innerWidth <= 700) {
      setSidebarOpen(false);
    }
  };
  return (
    <div className={`section-menu-left sidebar ${sidebarOpen ? "open" : ""}`}>
      {/* Logo Section */}
      <div className="box-logo">
        <NavLink to="/" id="site-logo-inner">
          <img
            id="logo_header"
            alt="Logo"
            src="/images/logo/logo.svg"
            data-light="images/logo/logo.svg"
            data-dark="images/logo/logo-dark.svg"
          />
        </NavLink>

        {/* ✅ Toggle button */}
        <div
          className="button-show-hide cursor-pointer"
          onClick={() => setSidebarOpen(!sidebarOpen)}
        >
          <FaChevronLeft />
        </div>
      </div>

      {/* Menu Wrap */}
      <div className="section-menu-left-wrap">
        <div className="center">
          <div className="center-item">
            <div className="center-heading f14-regular text-Gray menu-heading mb-12">
              Navigation
            </div>
          </div>

          <div className="center-item">
            <ul>
              {/* Dashboard */}
              <li className="menu-item">
                <NavLink
                  to="/dashboard"
                  className={({ isActive }) =>
                    `menu-item-button ${isActive ? "active" : ""}`
                  }
                  onClick={handleLinkClick}
                >
                  <div className="icon">
                    <FaThLarge />
                  </div>
                  <div className="text">Dashboard</div>
                </NavLink>
              </li>

              {/* Payment Link */}
              <li className="menu-item">
                <NavLink
                  to="/payment_link"
                  className={({ isActive }) =>
                    `menu-item-button ${isActive ? "active" : ""}`
                  }
                  onClick={handleLinkClick}
                >
                  <div className="icon">
                    <FaLink />
                  </div>
                  <div className="text">Payment Link</div>
                </NavLink>
                <ul className="sub-menu">
                  <li className="sub-menu-item">
                    <NavLink
                      to="/my-wallet"
                      className={({ isActive }) =>
                        `menu-link ${isActive ? "active" : ""}`
                      }
                      onClick={handleLinkClick}
                    >
                      <div className="text">My Wallet</div>
                    </NavLink>
                  </li>
                  <li className="sub-menu-item">
                    <NavLink
                      to="/account"
                      className={({ isActive }) =>
                        `menu-link ${isActive ? "active" : ""}`
                      }
                      onClick={handleLinkClick}
                    >
                      <div className="text">Account</div>
                    </NavLink>
                  </li>
                </ul>
              </li>

              {/* Receive Transaction */}
              <li className="menu-item">
                <NavLink
                  to="/Receive_transaction"
                  className={({ isActive }) =>
                    `menu-item-button ${isActive ? "active" : ""}`
                  }
                  onClick={handleLinkClick}
                >
                  <div className="icon">
                    <FaChartLine />
                  </div>
                  <div className="text">Receive Transaction</div>
                </NavLink>
              </li>

              {/* Send Transaction */}
              <li className="menu-item">
                <NavLink
                  to="/Send_transaction"
                  className={({ isActive }) =>
                    `menu-item-button ${isActive ? "active" : ""}`
                  }
                  onClick={handleLinkClick}
                >
                  <div className="icon">
                    <FaChartLine />
                  </div>
                  <div className="text">Send Transaction</div>
                </NavLink>
              </li>

              {/* Settlement */}
              <li className="menu-item">
                <NavLink
                  to="/Settelment"
                  className={({ isActive }) =>
                    `menu-item-button ${isActive ? "active" : ""}`
                  }
                  onClick={handleLinkClick}
                >
                  <div className="icon">
                    <FaBitcoin />
                  </div>
                  <div className="text">Settlement History</div>
                </NavLink>
              </li>

              {/* Developer Section */}
              <li className="menu-item">
                <NavLink
                  to="/developer_section"
                  className={({ isActive }) =>
                    `menu-item-button ${isActive ? "active" : ""}`
                  }
                  onClick={handleLinkClick}
                >
                  <div className="icon">
                    <FaExchangeAlt />
                  </div>
                  <div className="text">Developer Section</div>
                </NavLink>
              </li>

              {/* API Docs (external link) */}
              <li className="menu-item">
                <a
                  href="https://documenter.getpostman.com/view/45483161/2sB3QCRYM6"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="menu-item-button"
                  onClick={handleLinkClick}
                >
                  <div className="icon">
                    <FaCog />
                  </div>
                  <div className="text">API Documents</div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
